import React, { Component } from "react";
import "./services.css";
import app1 from "../../../../../assets/app.png";
import webdevelopment from "../../../../../assets/web developer.png";
import webmaintanance from "../../../../../assets/web maintanance.svg";
import digital from "../../../../../assets/digital.png";
import product from "../../../../../assets/web designer.png";
import branding from "../../../../../assets/branding.png";
import arrow from "../../../../../assets/arrow.png";
export default class Services extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 0,
      data: [
        {
          img: webdevelopment,
          h2: "Web Devlopment",
          p:
            "Web development is the work involved in developing a website for the internet or a intranet.web development can range from developing a simple static page of plain text to complex web-based applications , e-business and social network services.Web development is a wider concept it includes web engineering a web design web content development, web server, etc.",
        },
        {
          img: app1,
          h2: "App Devlopment",
          p: `App development is a process by which a mobile app is
          developed. The software that we use on a mobile phones
          are a result of app development. This platform is one
          of the fastest growing development all over the
          digital world with more than three billion people
          worldwide using smart phones spending around 90% of
          the mobile time in apps and over 100 million app
          downloads.`,
        },
        {
          img: product,
          h2: "Product Design",
          p: `Web designing is an art about laying out a visual
          structure of a website before actually creating it. It
          gives the developer an overview model to do coding . A
          good web design is one which fulfills all the needs of
          the customer and satisfies each and every aspect of
          the webpage. It enhances the look of the web page and
          lays a foreplan for the developer . The designing of a
          web page includes many things like logo design, footer
          design, illustrations, fonts and many different
          things.`,
        },
        {
          img: webmaintanance,
          h2: "Web Maintanance",
          p: `We understand your dilemma! You want the website to
          keep performing well and stay fruitful to you. At
          Intlum, we take pride in maintaining the website on
          your behalf, so that you don’t need to worry about the
          engagement and optimization of your website. We keep
          the flow of leads coming to our clients by maintaining
          their websites and we want to keep on doing so by
          maintaining the website and helping you retain the
          leads for your business and keeping its standard
          alive.`,
        },
        {
          img: digital,
          h2: "Digital Marketing",
          p: `Digital marketing Digital marketing is the use of the
          Internet, mobile devices, social media search engines,
          and other channels to reach consumers. Some marketing
          experts consider digital marketing to be an entirely
          new endeavor that requires a new way of approaching
          customers and new ways of understanding how customers
          behave compared to traditional marketing.`,
        },
        {
          img: branding,
          h2: "Branding",
          p: `Branding is very important for every company 
          Brandind gives your business an identity beyond its product and services.
          Branding makes your business memorable. It is the face of the company and help consumer distinguish your business. Brandinf supports yoir marketing and digital services `,
        },
      ],
    };
  }

  render() {
    return (
      <div className="services">
        <h1>Services We Provide</h1>
        <div className="services-body">
          {this.state.data.map((item) => {
            return (
              <div className="services-content">
                <div className="top">
                  <img src={item.img} alt="" />
                  <div className="content">
                    <h2>{item.h2}</h2>
                    <p>{item.p}</p>
                  </div>
                </div>
                <div className="bottom">
                  <img src={arrow} alt="" className="arrow" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
